import { render, staticRenderFns } from "./Kittens.vue?vue&type=template&id=146ec915&scoped=true"
import script from "./Kittens.vue?vue&type=script&lang=js"
export * from "./Kittens.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=146ec915&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ec915",
  null
  
)

export default component.exports